import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FundsPortalService, LocalStorageService } from 'src/app/core/core.module';
import { AtramModalComponent } from 'src/app/shared/components/atram-modal/atram-modal.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.less']
})
export class ChangePasswordComponent implements OnInit {
  @ViewChild('atramModal')
  public atramModal: AtramModalComponent = new AtramModalComponent;


  public searchFormGroup!: FormGroup; 

  public openNav: boolean = false;
  public clickOutside: boolean = false;
  public forgotPasswordCode: string = '';

  constructor(
    private renderer: Renderer2,
    public router: Router,
    public route: ActivatedRoute,
    public fundsPortalService: FundsPortalService,
    public localStorageService: LocalStorageService
  ) { 
    this.route.queryParams.subscribe(params => {
      this.forgotPasswordCode = params['code'];
      if(this.localStorageService.get('forgot_password_code') == null || (this.forgotPasswordCode != this.localStorageService.get('forgot_password_code'))){
        this.localStorageService.set('forgot_password_code', this.forgotPasswordCode, 9999);
      }
    });
  }

  ngOnInit(): void {
    if(this.localStorageService.get('bearer') !== null || this.localStorageService.isExpired('bearer')){
      // preserve bearer set by forgot-password flow for change_ps authorization
      this.localStorageService.remove('email');
      this.localStorageService.remove('mobile_number');
      this.localStorageService.remove('authorized');
    }
    this.initializeFormGroup();
    this.validateCode();
  }

  //#region Form Group Events
  initializeFormGroup(): void {
    this.searchFormGroup = new FormGroup({
      word: new FormControl('', [Validators.required,
                                     Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{12,15}$')]),
      confirmWord: new FormControl('', [Validators.required,
                                            Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{12,15}$')])
    });
  }

  //#region service calls

  validateCode(): Promise<any> {
    var body = {
      forgot_password_code: this.localStorageService.get('forgot_password_code'),
    }

    return new Promise<any>((resolve: any, reject: any) => {
      this.fundsPortalService.postValidateForgotPassword(body)
      .subscribe({
        next: (data:any) =>{
          resolve(data);
        },
        error: error =>{
          this.atramModal.show();
          this.atramModal.size = 'sm';
          this.atramModal.status = 'error';
          this.atramModal.headerText = 'Validation Failed';
          this.atramModal.bodyText = 'Incorrect forgot password Code';
          this.atramModal.okButtonText = 'Go to Sign-in';
          this.atramModal.showCancelButton = false;
          this.atramModal.showCloseButton = false;
          this.atramModal.confirmationSubject
            .subscribe((confirmation: boolean) => {
              if (confirmation) {
                // OK
                this.router.navigateByUrl(``, { skipLocationChange: false });
              } else {
                // Cancel
              }
              this.atramModal.hide();
            });
        }
      })
    });
  }

  proceed(): void {
    var word = this.searchFormGroup.get('word');
    var confirmWord = this.searchFormGroup.get('confirmWord');
    if (!word?.valid ||
      !confirmWord?.valid||
      word?.value != confirmWord?.value) {
        word?.markAsTouched();
        confirmWord?.markAsTouched();
        return;
    }
    else{
      this.submit();
    }
  }

  submit(): Promise<any> {
    let body = {  
      password: this.searchFormGroup.get('word')?.value,
      forgot_password_code: this.localStorageService.get('forgot_password_code')
    }

    return new Promise<any>((resolve: any, reject: any) => {
      this.fundsPortalService.postChangePassword(body)
      .subscribe({
        next: (data:any) =>{
          resolve(data);
          if (data['response_result'] === '0001'){
            this.continueToPostResetFlow();
            return;
          }
        },
        error: (error: any) =>{
            const errorMessage =
              error?.response_description ||
              error?.response_data?.message ||
              (typeof error === 'string' ? error : 'Unable to change password. Please try again.');

            this.atramModal.show();
            this.atramModal.size = 'sm';
            this.atramModal.status = 'error';
            this.atramModal.headerText = 'Change Password Failed';
            this.atramModal.bodyText = errorMessage;
            this.atramModal.okButtonText = 'Try Again';
            this.atramModal.showCancelButton = false;
            this.atramModal.showCloseButton = true;
            this.atramModal.confirmationSubject
              .subscribe((confirmation: boolean) => {
                if (confirmation) {
                  // Stay on page so user can retry without restarting forgot-password flow.
                } else {
                  // Cancel
                }
                this.atramModal.hide();
              });
            return;
          } 
      })
    });
  }

  goToSignIn(){
    this.router.navigateByUrl(`/`, { skipLocationChange: false });
  }

  private continueToPostResetFlow(): void {
    this.localStorageService.remove('forgot_password_code');
    this.localStorageService.remove('forgot_password_email');
    this.localStorageService.remove('forgot_password_company_code');

    this.atramModal.show();
    this.atramModal.size = 'sm';
    this.atramModal.status = 'password';
    this.atramModal.headerText = 'Password Change Successful!';
    this.atramModal.bodyText = 'Your password has been changed successfully. Please sign in with your new password.';
    this.atramModal.okButtonText = 'Go to Sign-in';
    this.atramModal.showCancelButton = false;
    this.atramModal.showCloseButton = false;
    this.atramModal.confirmationSubject.subscribe((confirmation: boolean) => {
      if (confirmation) {
        this.router.navigateByUrl('', { skipLocationChange: false });
      }
      this.atramModal.hide();
    });
  }

}

